import { CountryCodes } from '@/enums/general'
import {
  braintreeCreditCard,
  paypal, paynlIdeal, paynlBancontact, braintreeApplePay, braintreeGooglePay, paynlEPS
} from '@/enums/payments'

export default {
  computed: {
    paymentMethods () {
      const paymentMethods = {
        [CountryCodes.netherlands]: {
          ideal: { ...paynlIdeal }
        },
        [CountryCodes.belgium]: {
          bancontact: { ...paynlBancontact },
          creditcard: { ...braintreeCreditCard },
          googlepay: { ...braintreeGooglePay }
        },
        [CountryCodes.germany]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard }
        },
        [CountryCodes.denmark]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard },
          googlepay: { ...braintreeGooglePay }
        },
        [CountryCodes.austria]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard }
        },
        [CountryCodes.unitedKingdom]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard },
          googlepay: { ...braintreeGooglePay }
        },
        [CountryCodes.spain]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard },
          googlepay: { ...braintreeGooglePay }
        },
        [CountryCodes.france]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard }
        },
        [CountryCodes.sweden]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard }
        },
        [CountryCodes.italy]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard }
        },
        [CountryCodes.poland]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard },
          googlepay: { ...braintreeGooglePay }
        },
        [CountryCodes.switzerland]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard },
          googlepay: { ...braintreeGooglePay }
        },
        [CountryCodes.ireland]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard },
          googlepay: { ...braintreeGooglePay }
        },
        [CountryCodes.luxembourg]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard }
        },
        [CountryCodes.portugal]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard },
          googlepay: { ...braintreeGooglePay }
        },
        [CountryCodes.finland]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard },
          googlepay: { ...braintreeGooglePay }
        },
        [CountryCodes.norway]: {
          paypal: { ...paypal },
          creditcard: { ...braintreeCreditCard }
        },
        [CountryCodes.czechRepublic]: {
          creditcard: { ...braintreeCreditCard },
          googlepay: { ...braintreeGooglePay }
        }
      }

      // Verification Payment amounts
      paymentMethods[CountryCodes.sweden].creditcard.verificationAmount = 11
      paymentMethods[CountryCodes.denmark].creditcard.verificationAmount = 8
      paymentMethods[CountryCodes.unitedKingdom].creditcard.verificationAmount = 1
      paymentMethods[CountryCodes.italy].creditcard.verificationAmount = 1
      paymentMethods[CountryCodes.poland].creditcard.verificationAmount = 10
      paymentMethods[CountryCodes.norway].creditcard.verificationAmount = 11
      paymentMethods[CountryCodes.czechRepublic].creditcard.verificationAmount = 24

      return paymentMethods
    },
    isSocialPaid () {
      return this.$route.query.utm_medium === 'socialpaid'
    }
  },
  methods: {

    /**
     * We first check if there are paynl methods enabled for the country using a feature toggle since they must be
     * rendered on top, after that we take the static methods and finally the braintree ones that are toggle managed
     */
    Methods (countryCode, isManual) {
      return Object.freeze(
        [
          ...Object.keys(this.paymentMethods[countryCode]).map(key => this.paymentMethods[countryCode][key]),
          (this.isPayNLEPSEnabled(countryCode, isManual) ? { ...paynlEPS } : null),
          (this.isBraintreeApplePayEnabled(countryCode, isManual) ? { ...braintreeApplePay } : null)
        ].filter(item => item !== null)
      )
    },
    isBraintreeApplePayEnabled (countryCode, isManual) {
      if (isManual) {
        return true
      }

      if (this.isSocialPaid && countryCode === CountryCodes.unitedKingdom) {
        return true
      }

      return [
        CountryCodes.austria,
        CountryCodes.belgium,
        CountryCodes.switzerland,
        CountryCodes.czechRepublic,
        CountryCodes.germany,
        CountryCodes.denmark,
        CountryCodes.france,
        CountryCodes.ireland
      ].includes(countryCode)
    },
    isPayNLEPSEnabled (countryCode, isManual) {
      if (countryCode !== CountryCodes.austria) {
        return false
      }

      return isManual
    }
  }
}
